export default [{ value: 1, label: 'Not Started' },
{ value: 2, label: 'In Progress' },
{ value: 3, label: 'Completed' }]